import type { Resource } from '../../';
export const country_countries_ME: Resource = {"default":"Montenegro"};
